'use client'

import { BottomCTA, Text } from '@macarongfactory/web-ui'
import { useEffect, useRef } from 'react'

import { LOCK_AB_AF_SUB2 } from '../../_features/modoocar-lock-ab'
import { useLockAb } from '../../_features/modoocar-lock-ab/_hooks/useLockAb'
import {
  MODOOCAR_CODE,
  MODOOCAR_CTA_ONELINK_URL,
  MODOOCAR_EVENT,
  getAppCtaButtonText,
  useModoocarAppLink,
  useModoocarTracking,
} from '../_features/modoocar'

interface IBottomCtaProps {
  managingUserCount: number
}

const MOBILE_CTA_MAX_WIDTH_PX = 480

const BottomCta = ({ managingUserCount }: IBottomCtaProps) => {
  const {
    data: { isLock },
  } = useLockAb()
  const buttonText = getAppCtaButtonText(isLock)
  const { itemClick, track } = useModoocarTracking()
  const openAppLink = useModoocarAppLink({
    fallbackUrl: MODOOCAR_CTA_ONELINK_URL,
    afSub2: LOCK_AB_AF_SUB2.BOTTOM_CTA,
  })

  const shownRef = useRef(false)
  useEffect(() => {
    if (shownRef.current) return
    if (window.matchMedia('(min-width: 1024px)').matches) return
    shownRef.current = true
    track(MODOOCAR_EVENT.SECTION_SHOW, {
      code: MODOOCAR_CODE.BOTTOM_CTA,
      type: 'button',
      label: buttonText,
    })
  }, [track, buttonText])

  const handleClick = () =>
    openAppLink(() => itemClick(MODOOCAR_CODE.BOTTOM_CTA, 'button', buttonText))

  return (
    <div
      className='fixed bottom-0 left-0 right-0 z-50 mx-auto lg:hidden'
      style={{ maxWidth: MOBILE_CTA_MAX_WIDTH_PX }}
    >
      <BottomCTA.Vertical
        position='relative'
        top={
          <Text
            variant='title-2-medium'
            color='text-foreground-neutral-alternative'
            className='text-center'
          >
            {`이 차 오너 ${managingUserCount.toLocaleString()}명이 마이클에서 관리중`}
          </Text>
        }
        mainButton={
          <BottomCTA.MainButton.SolidButton
            text={buttonText}
            onClick={handleClick}
          />
        }
      />
      <div
        className='bg-background-surface-default'
        style={{ height: 'env(safe-area-inset-bottom)' }}
      />
    </div>
  )
}

export default BottomCta
